<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close(false)" color="primary">{{'FORMS.NO' | translate}}</button>
  <button mat-raised-button (click)="close(true)" color="primary">{{'FORMS.YES' | translate}}</button>
</mat-dialog-actions>
